// removed by extract-text-webpack-plugin
module.exports = {"Switch":"Switch__-loca-__2M1Z8","SwitchHelper":"Switch__-loca-__2yfL3","ReactSwitchCheckbox":"Switch__-loca-__1QSq4","ReactSwitchLabel":"Switch__-loca-__CCm45","ReactSwitchButton":"Switch__-loca-__125Ph"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Buttons/Switch/Switch.css
// module id = 71
// module chunks = 0